module.exports = __webpack_public_path__ + "img/azg_反白 1@2x.1e459c4a.png";